module.exports = __webpack_public_path__ + "static/media/emilyz.9fcf69e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emilyz.jpg
// module id = 683
// module chunks = 0